import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { Flex } from "antd";
import { Spin } from "antd";

function OpenRoute({ children }) {
  const { isAuthenticated, loading } = useSelector((state) => state.auth);
  const accountType = useSelector((state) => state?.profile?.user?.accountType);

  // While still checking cookies, don’t render or redirect yet
  if (loading) {
    return (
      <Flex justify="center" align="center" style={{ minHeight: '50vh' }}>
        <Spin size="large" tip="Loading..." />
      </Flex>
    );
  }

  // If not logged in → allow access to login/signup/etc.
  if (!isAuthenticated) {
    return children;
  }

  // If logged in → redirect based on account type
  if (accountType === "SuperAdmin") {
    return <Navigate to="/superadmin-dashboard" replace />;
  } else if (accountType === "Admin") {
    return <Navigate to="/admin-dashboard" replace />;
  } else if (accountType === "Employee") {
    return <Navigate to="/user-dashboard" replace />;
  } else {
    return <Navigate to="/features" replace />;
  }
}

export default OpenRoute;
